import axios from 'axios';

export type VerifyQuoteItem = {
	sku: string;
	hsProductId?: string | null;
	quantity: number;
	currentPrice: number;
	type: string;
	isFuelVariant?: boolean;
};

export type VerifiedQuoteItem = {
	sku: string;
	type: string;
	quantity: number;
	currentPrice: number;
	hubspotPrice: number | null;
	hubspotProductId: string | null;
	hubspotProductName: string | null;
	isFoundInHubspot: boolean;
	hasPriceMismatch: boolean;
	priceDifference: number | null;
	selectedPrice?: 'hubspot' | 'tool';
};

export type VerifyQuoteItemsSummary = {
	totalItems: number;
	foundItems: number;
	missingItems: number;
	itemsWithPriceMismatch: number;
	hasIssues: boolean;
};

export type VerifyQuoteItemsResult = {
	verifiedItems: VerifiedQuoteItem[];
	summary: VerifyQuoteItemsSummary;
};

export type VerifyQuoteItemsParams = {
	items: VerifyQuoteItem[];
	getToken: () => Promise<string>;
};

export const verifyQuoteItems = async (params: VerifyQuoteItemsParams): Promise<[VerifyQuoteItemsResult | null, string | null]> => {
	const { items, getToken } = params;

	try {
		const token = await getToken();
		const response = await axios.post<VerifyQuoteItemsResult>(
			`${import.meta.env.VITE_API_URL}/verify/quote-items`,
			{ items },
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		);

		if (response.status === 200) {
			return [response.data, null];
		}

		return [null, 'Error verifying quote items'];
	} catch {
		return [null, 'Error verifying quote items'];
	}
};
